import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import './styles/App.css';
import Homepage from './components/Homepage';
import Dashboard from './components/Dashboard';
import WelcomePage from './components/WelcomePage';
import SurveyPage from './components/SurveyPage';
import ActivitiesPage from './components/ActivitiesPage';
import ChallengeCompletePage from './components/ChallengeCompletePage';
import { getActivitiesUrl, getPostSurveyUrl, getPreSurveyUrl } from './config';
// Event configuration - in future this will come from backend
const EVENT_ID = 'hof-spring-2026';
const App = () => {
    const [currentView, setCurrentView] = useState('homepage');
    const [activeNav, setActiveNav] = useState('welcome');
    // Store join code for future use (e.g., displaying participant info)
    const [_joinCode, setJoinCode] = useState('');
    const [preSurveyComplete, setPreSurveyComplete] = useState(false);
    const handleJoinSuccess = (code) => {
        setJoinCode(code);
        setCurrentView('dashboard');
    };
    const handleNavChange = (nav) => {
        setActiveNav(nav);
    };
    const handleGetStarted = () => {
        // Navigate to pre-survey when user clicks "Get Started" on welcome page
        setActiveNav('pre-survey');
    };
    const handlePreSurveyComplete = () => {
        // Mark pre-survey as complete and navigate to activities
        setPreSurveyComplete(true);
        setActiveNav('activities');
    };
    const handleActivitiesComplete = () => {
        // Navigate to post-survey after completing activities
        setActiveNav('post-survey');
    };
    const handlePostSurveyComplete = () => {
        // Show the challenge complete page
        setCurrentView('complete');
    };
    const handleChallengeClose = () => {
        // Reset to homepage after completing the challenge
        setCurrentView('homepage');
        setActiveNav('welcome');
        setPreSurveyComplete(false);
    };
    // Render dashboard content based on active nav
    const renderDashboardContent = () => {
        switch (activeNav) {
            case 'welcome':
                return _jsx(WelcomePage, { onGetStarted: handleGetStarted });
            case 'pre-survey':
                return (_jsx(SurveyPage, { surveyUrl: getPreSurveyUrl(), onComplete: handlePreSurveyComplete }));
            case 'activities':
                return (_jsx(ActivitiesPage, { activitiesUrl: getActivitiesUrl(), onComplete: handleActivitiesComplete }));
            case 'post-survey':
                return (_jsx(SurveyPage, { surveyUrl: getPostSurveyUrl(), onComplete: handlePostSurveyComplete }));
            default:
                return _jsx(WelcomePage, { onGetStarted: handleGetStarted });
        }
    };
    if (currentView === 'complete') {
        return _jsx(ChallengeCompletePage, { onClose: handleChallengeClose });
    }
    if (currentView === 'dashboard') {
        return (_jsx(Dashboard, { activeNav: activeNav, onNavChange: handleNavChange, preSurveyComplete: preSurveyComplete, children: renderDashboardContent() }));
    }
    return _jsx(Homepage, { onJoinSuccess: handleJoinSuccess });
};
export default App;
